import { render, staticRenderFns } from "./StakewiseStaking.vue?vue&type=template&id=fff71136&scoped=true"
import script from "./StakewiseStaking.vue?vue&type=script&lang=js"
export * from "./StakewiseStaking.vue?vue&type=script&lang=js"
import style0 from "./StakewiseStaking.vue?vue&type=style&index=0&id=fff71136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff71136",
  null
  
)

export default component.exports